interface BillsUrlFilters {
    billIds?: string[];
    entityIds?: number[];
    counterpartiesIds?: string[];
}

interface BillsUrlParams {
    /** Deep-links the Schedule column into view with this policy on top. */
    scheduleTemplateId?: string;
}

export function createBillsUrl(
    filters: BillsUrlFilters,
    params: BillsUrlParams = {},
): string {
    const queryParts: string[] = [];
    const serialized = JSON.stringify(filters);
    if (serialized && serialized !== "{}") {
        queryParts.push(`filters=${encodeURIComponent(serialized)}`);
    }
    if (params.scheduleTemplateId) {
        queryParts.push(
            `scheduleTemplateId=${encodeURIComponent(params.scheduleTemplateId)}`,
        );
    }
    return queryParts.length > 0
        ? `/billing?${queryParts.join("&")}`
        : "/billing";
}
